<section
  *ngIf="activeBanner as event"
  class="homepage-event-banner site-content-container"
  aria-labelledby="homepage-event-banner-title"
>
  <div class="homepage-event-banner__card">
    <div class="homepage-event-banner__layout">
      <div class="homepage-event-banner__media">
        <img
          [src]="event.imageUrl"
          [alt]="event.imageAlt"
          class="homepage-event-banner__image"
          decoding="async"
        />
      </div>
      <div class="homepage-event-banner__content">
        <span
          class="homepage-event-banner__badge"
          [class.homepage-event-banner__badge--live]="event.status === 'LIVE'"
        >
          {{ event.status === 'LIVE' ? 'Live Now' : 'Upcoming Live Event' }}
        </span>
        <h2 id="homepage-event-banner-title" class="homepage-event-banner__title">
          {{ event.title }}
        </h2>
        <p class="homepage-event-banner__meta">
          <app-icon
            name="calendar-days"
            class="cx-icon--sm"
            aria-hidden="true"
          ></app-icon>
          <span>{{ formatEventTime(event) }} · {{ event.timezoneLabel }}</span>
        </p>
        <p class="homepage-event-banner__description">{{ event.description }}</p>
        <p class="homepage-event-banner__supporting-text">
          RSVP to join this community conversation.
        </p>
        <div class="homepage-event-banner__actions">
          <a
            data-testid="homepage-banner-sign-up"
            class="btn homepage-event-banner__action homepage-event-banner__action--primary"
            [routerLink]="['/signup']"
            [queryParams]="{ returnUrl: rsvpReturnUrl }"
          >
            <app-icon
              name="user-plus"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            Sign Up &amp; RSVP
          </a>
          <a
            data-testid="homepage-banner-log-in"
            class="btn homepage-event-banner__action homepage-event-banner__action--secondary"
            [routerLink]="['/login']"
            [queryParams]="{ returnUrl: rsvpReturnUrl }"
          >
            <app-icon
              name="log-in"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            Log In &amp; RSVP
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
